var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _circle, _g5, _circle2, _g6, _circle3, _g7, _circle4, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _line, _line2, _line3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 147,
    height: 147,
    rx: 23.5,
    stroke: "url(#paint0_linear_1418_13961)",
    strokeOpacity: 0.1,
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.833 28.2643C120.798 25.5788 119.771 23.7224 119.214 22.9095C119.07 22.7004 118.764 22.7265 118.653 22.9554C118.482 23.307 118.208 23.7515 117.835 23.9829C117.835 23.9829 116.253 22.665 116.179 20.6905C116.171 20.4652 115.953 20.3129 115.746 20.3854C114.909 20.6799 113.131 21.6692 112.702 24.821C112.349 24.1638 111.511 23.9718 110.973 23.9178C110.748 23.8952 110.567 24.1095 110.623 24.3351C111.033 25.991 110 26.9804 110 28.4033C110 31.4908 112.417 33.9948 115.401 34.0036C118.431 34.0125 120.873 31.3965 120.833 28.2643Z",
    fill: "url(#paint1_linear_1418_13961)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.187 26.8971C122.152 24.2117 121.125 22.3552 120.568 21.5423C120.424 21.3332 120.118 21.3593 120.007 21.5882C119.836 21.9398 119.562 22.3843 119.189 22.6157C119.189 22.6157 117.607 21.2978 117.533 19.3233C117.525 19.098 117.307 18.9457 117.1 19.0183C116.263 19.3128 114.485 20.302 114.056 23.4538C113.703 22.7966 112.865 22.6046 112.327 22.5506C112.102 22.528 111.921 22.7423 111.977 22.9679C112.387 24.6238 111.354 25.6132 111.354 27.0361C111.354 30.1236 113.771 32.6276 116.755 32.6364C119.785 32.6453 122.227 30.0294 122.187 26.8971Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.833 60.2643C120.798 57.5788 119.771 55.7224 119.214 54.9095C119.07 54.7004 118.764 54.7265 118.653 54.9554C118.482 55.307 118.208 55.7515 117.835 55.9829C117.835 55.9829 116.253 54.665 116.179 52.6905C116.171 52.4652 115.953 52.3129 115.746 52.3854C114.909 52.6799 113.131 53.6692 112.702 56.821C112.349 56.1638 111.511 55.9718 110.973 55.9178C110.748 55.8952 110.567 56.1095 110.623 56.3351C111.033 57.991 110 58.9804 110 60.4033C110 63.4908 112.417 65.9948 115.401 66.0036C118.431 66.0125 120.873 63.3965 120.833 60.2643Z",
    fill: "url(#paint2_linear_1418_13961)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.187 58.8971C122.152 56.2117 121.125 54.3552 120.568 53.5423C120.424 53.3332 120.118 53.3593 120.007 53.5882C119.836 53.9398 119.562 54.3843 119.189 54.6157C119.189 54.6157 117.607 53.2978 117.533 51.3233C117.525 51.098 117.307 50.9457 117.1 51.0183C116.263 51.3128 114.485 52.302 114.056 55.4538C113.703 54.7966 112.865 54.6046 112.327 54.5506C112.102 54.528 111.921 54.7423 111.977 54.9679C112.387 56.6238 111.354 57.6132 111.354 59.0361C111.354 62.1236 113.771 64.6276 116.755 64.6364C119.785 64.6453 122.227 62.0294 122.187 58.8971Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.833 92.2643C120.798 89.5788 119.771 87.7224 119.214 86.9095C119.07 86.7004 118.764 86.7265 118.653 86.9554C118.482 87.307 118.208 87.7515 117.835 87.9829C117.835 87.9829 116.253 86.665 116.179 84.6905C116.171 84.4652 115.953 84.3129 115.746 84.3854C114.909 84.6799 113.131 85.6692 112.702 88.821C112.349 88.1638 111.511 87.9718 110.973 87.9178C110.748 87.8952 110.567 88.1095 110.623 88.3351C111.033 89.991 110 90.9804 110 92.4033C110 95.4908 112.417 97.9948 115.401 98.0036C118.431 98.0125 120.873 95.3965 120.833 92.2643Z",
    fill: "url(#paint3_linear_1418_13961)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.187 90.8971C122.152 88.2117 121.125 86.3552 120.568 85.5423C120.424 85.3332 120.118 85.3593 120.007 85.5882C119.836 85.9398 119.562 86.3843 119.189 86.6157C119.189 86.6157 117.607 85.2978 117.533 83.3233C117.525 83.098 117.307 82.9457 117.1 83.0183C116.263 83.3128 114.485 84.302 114.056 87.4538C113.703 86.7966 112.865 86.6046 112.327 86.5506C112.102 86.528 111.921 86.7423 111.977 86.9679C112.387 88.6238 111.354 89.6132 111.354 91.0361C111.354 94.1236 113.771 96.6276 116.755 96.6364C119.785 96.6453 122.227 94.0294 122.187 90.8971Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.833 124.264C120.798 121.579 119.771 119.722 119.214 118.909C119.07 118.7 118.764 118.726 118.653 118.955C118.482 119.307 118.208 119.752 117.835 119.983C117.835 119.983 116.253 118.665 116.179 116.691C116.171 116.465 115.953 116.313 115.746 116.385C114.909 116.68 113.131 117.669 112.702 120.821C112.349 120.164 111.511 119.972 110.973 119.918C110.748 119.895 110.567 120.109 110.623 120.335C111.033 121.991 110 122.98 110 124.403C110 127.491 112.417 129.995 115.401 130.004C118.431 130.013 120.873 127.397 120.833 124.264Z",
    fill: "url(#paint4_linear_1418_13961)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.187 122.897C122.152 120.212 121.125 118.355 120.568 117.542C120.424 117.333 120.118 117.359 120.007 117.588C119.836 117.94 119.562 118.384 119.189 118.616C119.189 118.616 117.607 117.298 117.533 115.323C117.525 115.098 117.307 114.946 117.1 115.018C116.263 115.313 114.485 116.302 114.056 119.454C113.703 118.797 112.865 118.605 112.327 118.551C112.102 118.528 111.921 118.742 111.977 118.968C112.387 120.624 111.354 121.613 111.354 123.036C111.354 126.124 113.771 128.628 116.755 128.636C119.785 128.645 122.227 126.029 122.187 122.897Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4667,
    cy: 26.5331,
    r: 7.4667,
    fill: "url(#paint5_linear_1418_13961)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5324,
    cy: 25.4667,
    r: 7.4667,
    fill: "white",
    fillOpacity: 0.1
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4667,
    cy: 58.5331,
    r: 7.4667,
    fill: "url(#paint6_linear_1418_13961)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5324,
    cy: 57.4667,
    r: 7.4667,
    fill: "white",
    fillOpacity: 0.1
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4667,
    cy: 90.5331,
    r: 7.4667,
    fill: "url(#paint7_linear_1418_13961)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5324,
    cy: 89.4667,
    r: 7.4667,
    fill: "white",
    fillOpacity: 0.1
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4667,
    cy: 122.533,
    r: 7.4667,
    fill: "url(#paint8_linear_1418_13961)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5324,
    cy: 121.467,
    r: 7.4667,
    fill: "white",
    fillOpacity: 0.1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 23,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 23,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 23,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 55,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 55,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 55,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 87,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 87,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 87,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 119,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 119,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_b_1418_13961)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 119,
    width: 16,
    height: 6,
    rx: 2,
    fill: "white",
    fillOpacity: 0.1
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 105.5,
    x2: 136,
    y2: 105.5,
    stroke: "url(#paint9_linear_1418_13961)",
    strokeOpacity: 0.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 73.5,
    x2: 136,
    y2: 73.5,
    stroke: "url(#paint10_linear_1418_13961)",
    strokeOpacity: 0.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 41.5,
    x2: 136,
    y2: 41.5,
    stroke: "url(#paint11_linear_1418_13961)",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1418_13961",
    x: 109.054,
    y: 16.7,
    width: 15.4333,
    height: 18.2367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1418_13961",
    x: 109.054,
    y: 48.7,
    width: 15.4333,
    height: 18.2367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_1418_13961",
    x: 109.054,
    y: 80.7,
    width: 15.4333,
    height: 18.2367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_1418_13961",
    x: 109.054,
    y: 112.7,
    width: 15.4333,
    height: 18.2367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_1418_13961",
    x: 24.0657,
    y: 17,
    width: 16.9333,
    height: 16.9336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_1418_13961",
    x: 24.0657,
    y: 49,
    width: 16.9333,
    height: 16.9336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_1418_13961",
    x: 24.0657,
    y: 81,
    width: 16.9333,
    height: 16.9336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_1418_13961",
    x: 24.0657,
    y: 113,
    width: 16.9333,
    height: 16.9336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_1418_13961",
    x: -153,
    y: -177,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_1418_13961",
    x: -133,
    y: -177,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_1418_13961",
    x: -113,
    y: -177,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_1418_13961",
    x: -153,
    y: -145,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_1418_13961",
    x: -133,
    y: -145,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_b_1418_13961",
    x: -113,
    y: -145,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_b_1418_13961",
    x: -153,
    y: -113,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_b_1418_13961",
    x: -133,
    y: -113,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_b_1418_13961",
    x: -113,
    y: -113,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_b_1418_13961",
    x: -153,
    y: -81,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_b_1418_13961",
    x: -133,
    y: -81,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_b_1418_13961",
    x: -113,
    y: -81,
    width: 416,
    height: 406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 100
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1418_13961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1418_13961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1418_13961",
    x1: 74,
    y1: 0,
    x2: 74,
    y2: 148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1418_13961",
    x1: 121.736,
    y1: 20.3672,
    x2: 114.063,
    y2: 35.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1418_13961",
    x1: 121.736,
    y1: 52.3672,
    x2: 114.063,
    y2: 67.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1418_13961",
    x1: 121.736,
    y1: 84.3672,
    x2: 114.063,
    y2: 99.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1418_13961",
    x1: 121.736,
    y1: 116.367,
    x2: 114.063,
    y2: 131.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26B41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1418_13961",
    x1: 31.4667,
    y1: 19.0664,
    x2: 31.4667,
    y2: 33.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#846DB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29336B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1418_13961",
    x1: 31.4667,
    y1: 51.0664,
    x2: 31.4667,
    y2: 65.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DB4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#296B33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1418_13961",
    x1: 31.4667,
    y1: 83.0664,
    x2: 31.4667,
    y2: 97.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD8771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B2929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1418_13961",
    x1: 31.4667,
    y1: 115.066,
    x2: 31.4667,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEBB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A927"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1418_13961",
    x1: 74,
    y1: 106,
    x2: 74,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1418_13961",
    x1: 74,
    y1: 74,
    x2: 74,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1418_13961",
    x1: 74,
    y1: 42,
    x2: 74,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.9fe4484f0f0130e35c869caba2cb6907.svg";
export { ForwardRef as ReactComponent };